










import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ComparativeScore from "./ComparativeScore.vue";
import * as services from "@/services/analyses";
import { Analysis } from "@/api/analyses/types";

@Component({
  name: "ComparativeScoreController",
  components: {
    ComparativeScore,
  },
})
export default class ComparativeScoreController extends Vue {
  @Prop({ type: Object, required: true })
  private analysis!: Analysis;

  @Prop({ type: String, required: true })
  private harvestSeason!: string;

  @Prop({ type: String, required: true })
  private cropType!: string;

  private loaded = false;

  private async mounted() {
    await this.loadChartData();
    this.loaded = true;
  }

  private async loadChartData() {
    this.$emit('update:loading', true);
    try {
      await services.getComparativeScoreByHarvestAndCropType(
        this.analysis.uuid,
        this.harvestSeason,
        this.cropType
      );
    } finally {
      this.$emit('update:loading', false);
    }
  }

  get fetchKey() {
    return `${this.harvestSeason}:${this.cropType}`;
  }

  @Watch('fetchKey')
  private async onFetchKeyChange() {
    await this.loadChartData();
  }

  get getComparativeScoreItens() {
    return this.$store.state.analyses.comparativeScoreContext;
  }
}
